import React from 'react'
import SearchResults from '@chegg-wt/core/components/SearchResults'
import { Region } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { SourceType, JournalType, Source } from '@chegg-wt/core/types/core'
import CitationSearchInput from '../../CitationSearchInput'
import { Container } from './styled'
import { CITATION_SEARCH } from './utils/testIds'

export interface CitationSearchProps {
  afterFirstSource?: React.ReactNode
  afterSecondSource?: React.ReactNode
  isOverflow?: boolean
  searchText: string
  citationStyle: string
  sourceType: SourceType
  initialSearchQuery?: string
  loading: boolean
  error: boolean
  sources: Source[]
  journalType: JournalType
  invalidSearch: boolean
  onChangeSourceType: (sourceType: SourceType) => void
  onChangeSearchQuery: (searchQuery: string) => void
  onChangeJournalType: (journalType: JournalType) => void
  onSelectSource: (source: Source, index?: number) => void
  onManualCiteClick: (region: Region) => void
}

const CitationSearch: React.FC<CitationSearchProps> = ({
  afterFirstSource,
  afterSecondSource,
  isOverflow = true,
  searchText,
  citationStyle,
  sourceType,
  initialSearchQuery,
  loading,
  error,
  sources,
  journalType,
  invalidSearch,
  onChangeSourceType,
  onChangeSearchQuery,
  onChangeJournalType,
  onSelectSource,
  onManualCiteClick,
}) => (
  <Container data-test={CITATION_SEARCH}>
    <CitationSearchInput
      onChangeSourceType={onChangeSourceType}
      sourceType={sourceType}
      initialSearchQuery={initialSearchQuery}
      onChangeSearchQuery={onChangeSearchQuery}
      onManualCiteClick={onManualCiteClick}
    />
    <SearchResults
      afterFirstSource={afterFirstSource}
      afterSecondSource={afterSecondSource}
      isOverflow={isOverflow}
      searchText={searchText}
      citationStyle={citationStyle}
      sourceType={sourceType}
      sources={sources}
      loading={loading}
      error={error}
      journalType={journalType}
      invalidSearch={invalidSearch}
      onSelectSource={onSelectSource}
      onChangeJournalType={onChangeJournalType}
      onChangeSourceType={onChangeSourceType}
      onManualCiteClick={onManualCiteClick}
    />
  </Container>
)

export default CitationSearch
